import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'tzDate',
  pure: true
})
export class TZDatePipe implements PipeTransform {
  transform(
    value: Date | string | number | null | undefined,
    format: string = 'mediumDate',
    timezone: string = 'Europe/London',
    locale?: string
  ): string | null {
    if (value == null) {
      return null;
    }

    // Convert the input value into a Luxon DateTime object.
    let dt: DateTime;
    if (value instanceof Date) {
      dt = DateTime.fromJSDate(value);
    } else if (typeof value === 'number') {
      dt = DateTime.fromMillis(value);
    } else if (typeof value === 'string') {
      dt = DateTime.fromISO(value);
      // Fallback if the ISO parse fails.
      if (!dt.isValid) {
        dt = DateTime.fromJSDate(new Date(value));
      }
    } else {
      return null;
    }

    // If a timezone is provided, set it on the DateTime.
    if (timezone) {
      dt = dt.setZone(timezone);
    }

    // Set locale if provided.
    if (locale) {
      dt = dt.setLocale(locale);
    }

    // Map common Angular named formats to Luxon preset formats.
    const namedFormats: { [key: string]: Intl.DateTimeFormatOptions } = {
      short: DateTime.DATETIME_SHORT,
      medium: DateTime.DATETIME_MED,
      long: DateTime.DATETIME_FULL,
      full: DateTime.DATETIME_HUGE,
      shortDate: DateTime.DATE_SHORT,
      mediumDate: DateTime.DATE_MED,
      longDate: DateTime.DATE_FULL,
      fullDate: DateTime.DATE_HUGE,
      shortTime: DateTime.TIME_SIMPLE,
      mediumTime: DateTime.TIME_WITH_SECONDS,
      longTime: DateTime.TIME_WITH_SHORT_OFFSET,
    };

    // Use a named format if available, otherwise assume a custom format string.
    if (namedFormats[format]) {
      return dt.toLocaleString(namedFormats[format]);
    } else {
      return dt.toFormat(format);
    }
  }
}
